import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "user",
  initialState: {
    allTokens: {},
  },
  reducers: {
    tokens: (state) => ({ ...state }),
    setTokens(state, { payload }) {
      state.allTokens = payload.response;
    },
  },
});

export const { setTokens, tokens } = slice.actions;
export default slice.reducer;
